import React from "react";
import { useIntl } from "react-intl";
import _ from 'lodash';

//Components
import { Grid, Alert } from "@mui/material";
import { Pill } from "Components";

//Views
import General from 'Modules/.common/components/CameraSetup/.components/cameraConfig/general';
import Summary from 'Modules/.common/components/CameraSetup/.components/cameraConfig/summary';
import Events from 'Modules/.common/components/CameraSetup/.components/cameraConfig/events';
import ADAS from 'Modules/.common/components/CameraSetup/.components/cameraConfig/adas';
import DMS from 'Modules/.common/components/CameraSetup/.components/cameraConfig/dms';

const Main = (props) => {
    const { messages } = useIntl();

    const {
        setCameraConfigPillSelected,
        cameraConfigPillSelected,
        deviceModelSelected,
        vehicleClassOptions,
        setFormDataCamera,
        setCameraChanges,
        setVehicleClass,
        formDataCamera,
        confirmChanges,
        cameraChanges,
        vehicleClass,
        setErrors,
        errors,
        units,
        bulk,
        bulkMode
    } = props;

    //Variables
    const cameraConfig = {
        GENERAL: 0,
        EVENTS: 1,
        DMS: 2,
        ADAS: 3
    }

    const settingsPill = [
        {
            name: messages['cameraSetup_general'],
            id: cameraConfig.GENERAL,
            visible: true
        },
        {
            name: messages['cameraSetup_events'],
            id: cameraConfig.EVENTS,
            visible: true
        },
        {
            name: messages['cameraSetup_dms'],
            id: cameraConfig.DMS,
            visible: true
        },
        {
            name: messages['cameraSetup_adas'],
            id: cameraConfig.ADAS,
            visible: true
        }
    ];

    const renderPillSelected = () => {
        switch (cameraConfigPillSelected) {
            case cameraConfig.GENERAL:
                return <General
                    formDataCamera={formDataCamera}
                    setFormDataCamera={setFormDataCamera}
                    setCameraChanges={setCameraChanges}
                    vehicleClass={vehicleClass}
                    setVehicleClass={setVehicleClass}
                    vehicleClassOptions={vehicleClassOptions}
                    unit={units?.length ? units[0] : null}
                    deviceModelSelected={deviceModelSelected}
                />
            case cameraConfig.EVENTS:
                return <Events
                    formDataCamera={formDataCamera}
                    setFormDataCamera={setFormDataCamera}
                    setCameraChanges={setCameraChanges}
                />
            case cameraConfig.DMS:
                return <DMS
                    formDataCamera={formDataCamera}
                    setFormDataCamera={setFormDataCamera}
                    setCameraChanges={setCameraChanges}
                    setErrors={setErrors}
                    errors={errors}
                    unit={units?.length ? units[0] : null}
                    deviceModelSelected={deviceModelSelected}
                />
            case cameraConfig.ADAS:
                return <ADAS
                    formDataCamera={formDataCamera}
                    setFormDataCamera={setFormDataCamera}
                    setCameraChanges={setCameraChanges}
                    setErrors={setErrors}
                    errors={errors}
                    unit={units?.length ? units[0] : null}
                    deviceModelSelected={deviceModelSelected}
                />
            default:
                return null;
        }
    }

    return (
        <div style={{ padding: !bulkMode && 24, marginBottom: 30 }}>
            {
                confirmChanges && !bulkMode ? <Summary
                    changes={cameraChanges}
                    vehicleClass={vehicleClass}
                    vehicleClassOptions={vehicleClassOptions}
                /> : (
                    <>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={1}
                            style={{ marginBottom: 5 }}
                        >
                            {
                                settingsPill.map((filter, index) => {
                                    if (filter.visible) {
                                        let outlined = true;
                                        if (filter.id === cameraConfigPillSelected) {
                                            outlined = false;
                                        }
                                        return (
                                            <Grid
                                                item
                                                xs
                                                key={index}
                                            >
                                                <Pill
                                                    textField={'name'}
                                                    item={filter}
                                                    outlined={outlined}
                                                    onClick={() => setCameraConfigPillSelected(filter.id)}
                                                    className="camera-setup-options"
                                                    label="pill-label-text"
                                                    colorField="default"
                                                    colorSelection="005bf8"
                                                />
                                            </Grid>
                                        )
                                    }
                                })
                            }
                        </Grid>
                        {
                            formDataCamera?.noData &&
                            <Alert severity="warning">{messages['cameraSetup_no_data']}</Alert>
                        }
                        {renderPillSelected(cameraConfigPillSelected)}
                    </>
                )
            }
        </div>
    )

}

export default Main